import React, { Component } from "react";
import { FaMinusCircle } from "react-icons/fa";

import { TagInput, TagInputType } from "../../../../../../../Components/TagInput/TagInput";
import "./URLNodeCondition.scss";

interface URLNodeConditionProps {
  arrayName: string;
  arrayIndex: number;
  condition: any;
  name: string;
  onChange: any;
  delete: any;
}
export default class URLNodeCondition extends React.Component<URLNodeConditionProps> {
  constructor(props: URLNodeConditionProps) {
    super(props);
    this.deletePressed = this.deletePressed.bind(this);
    //this.moveItemInArray = this.moveItemInArray.bind(this)
  }
  deletePressed() {
    this.props.delete(this.props.arrayName, this.props.arrayIndex);
  }
  // moveItemInArray(arrayName, itemIndex, up) { // NEed a special move item in array method so we dont move past ELSE
  //   if (itemIndex != this.props.conditions.length - 2) {
  //   }
  // }

  render() {
    return (
      <div className="URLNodeCondition">
        <div className="deleteButton" onClick={this.deletePressed}>
          <FaMinusCircle />
        </div>
        PATH <small>(example: "/shop/sneakers")</small>
        <TagInput type={TagInputType.SingleLine} value={this.props.condition.value} onChange={this.props.onChange} name={this.props.name} />
        {/* <input value={this.props.condition.value} onChange={this.props.onChange} name={this.props.name }/> */}
      </div>
    );
  }
}
